export class MyGame extends Phaser.Game {
	constructor(config: Phaser.Types.Core.GameConfig) {
		super(config)
	}
}
